import { UpdateStatusesLegacy } from '../../../components/vulnerability-status'
import { createNgReactBridgeDirective } from '../../react-bridge'
import React from 'react'

interface Vulnerability {
  uuid: string
  application: {
    roles: string[]
  }
  status: string
  pending_status?: string
  pending_status_creation_time?: string
}

interface Props {
  vulnerabilities: Vulnerability[]
  refresh: () => Promise<any>
  organizationUuid: string
}

function UpdateStatusesWrapper({
  organizationUuid,
  vulnerabilities,
  refresh
}: Props) {
  if (!organizationUuid) {
    throw new Error('organizationUuid is required')
  }
  return (
    <UpdateStatusesLegacy
      organizationUuid={organizationUuid}
      vulnerabilities={vulnerabilities}
      refresh={refresh}
    />
  )
}

export const updateStatuses = createNgReactBridgeDirective(
  'reactUpdateStatuses',
  [],
  UpdateStatusesWrapper,
  ['vulnerabilities', 'refresh', 'organizationUuid']
)
